import { Pipe, PipeTransform } from '@angular/core';

export interface VisiblePagesInput {
  pageNumber: number;
  totalPages: number;
}

@Pipe({
  name: 'visiblePages',
  standalone: true,
})
export class VisiblePagesPipe implements PipeTransform {
  transform(value: VisiblePagesInput | null | undefined): number[] {
    const total = value?.totalPages ?? 0;
    if (total < 1) {
      return [];
    }

    const current = value!.pageNumber;
    let start = Math.max(current - 1, 1);
    let end = Math.min(start + 2, total);
    if (end - start < 2) {
      start = Math.max(end - 2, 1);
    }

    const pages: number[] = [];
    for (let i = start; i <= end; i++) {
      pages.push(i);
    }
    return pages;
  }
}
